import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { CART_QUERY_NAME } from '@pylot-data/core-queries/cart'
import { mutate } from 'swr'

const CREATE_CART_QUERY = /* GraphQL */ `
    mutation {
        createEmptyCart
    }
`

export const CREATING_CART_KEY = 'creating_cart'

type CreateCartType = (options: {
    locale?: string
}) => Promise<string | undefined>

export const createCart: CreateCartType = async ({ locale = '' }) => {
    const isClient = typeof window !== 'undefined'
    const isSavedCart = isClient && window.localStorage.getItem('cart_id')
    const isSignedIn = isClient && window.localStorage.getItem('pylot_token')
    const isCreatingCart = !!localStorage.getItem(CREATING_CART_KEY)

    const shouldMakeCart =
        isClient && !isSavedCart && !isSignedIn && !isCreatingCart

    if (shouldMakeCart) {
        // add a flag that cart is being created
        localStorage.setItem(CREATING_CART_KEY, '1')
        const res = await graphqlFetch<null, { createEmptyCart: string }>({
            query: CREATE_CART_QUERY,
            locale
        })
        window.localStorage.setItem('cart_id', res.data.createEmptyCart)
        localStorage.removeItem(CREATING_CART_KEY)

        mutate(`arg@"${CART_QUERY_NAME}"`, null)

        return res.data.createEmptyCart
    } else return undefined
}
